// In a new file: src/utils/network.js
export const checkNetworkStatus = () => {
  return navigator.onLine;
};

export const addNetworkListeners = (onlineCallback, offlineCallback) => {
  window.addEventListener('online', onlineCallback);
  window.addEventListener('offline', offlineCallback);
  
  return () => {
    window.removeEventListener('online', onlineCallback);
    window.removeEventListener('offline', offlineCallback);
  };
};